import * as e from "react";
import { forwardRef as C } from "react";
const n = C(function(l, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...l
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12.3709 9.02164V11.3991H20.77C20.6659 9.3687 19.885 7.52924 18.6355 6.08891C17.0563 7.78956 14.8351 8.9002 12.3709 9.02164ZM5.79392 18.3752C7.26896 19.7635 9.24726 20.6659 11.4165 20.77V15.6854C9.19521 15.8069 7.19955 16.8134 5.79392 18.3752ZM11.4165 14.7483V12.3536H3C3.10412 14.3839 3.88503 16.2407 5.13448 17.6811C6.71365 15.963 8.9349 14.8698 11.4165 14.7483ZM12.3709 15.6854V20.77C14.5401 20.6659 16.501 19.7635 17.9761 18.3752C16.5878 16.8134 14.5921 15.8069 12.3709 15.6854ZM11.4165 11.3991V9.02164C8.9349 8.9002 6.71365 7.78956 5.13448 6.08891C3.88503 7.52924 3.10412 9.3687 3 11.3991H11.4165ZM12.3709 12.3536V14.7483C14.8351 14.8698 17.0563 15.963 18.6355 17.6811C19.885 16.2407 20.6659 14.3839 20.77 12.3536H12.3709ZM11.4165 8.08456V3C9.24726 3.10413 7.26896 4.00651 5.79392 5.39478C7.19955 6.93924 9.19521 7.94575 11.4165 8.08456ZM17.9761 5.39478C16.501 4.00651 14.5401 3.10413 12.3709 3V8.08456C14.5921 7.94575 16.5878 6.93924 17.9761 5.39478Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Basketball
};
